module.exports = __webpack_public_path__ + "img/link.317b045f.svg";